import { Injectable } from "@angular/core";
import { ResponseCommonSI } from "@interfaces/services/common.interfaces";
import { firstValueFrom } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { BASE_URL, ENDPOINTS } from "@core/config/constants";
import { ConfirmSI, DetailCompanySI, ProjectDetailCompany } from "@views/interfaces/services/confirm";
import { EmitPolicySI } from "@views/interfaces/services/emission";

@Injectable({
  providedIn: "root",
})
export class EmissionService {

  constructor(
    private http: HttpClient
  ) { }

  async emitPolicy(): Promise<EmitPolicySI> {
    const result = await firstValueFrom<ResponseCommonSI<EmitPolicySI>>(this.http.post(`${BASE_URL}${ENDPOINTS.EMIT_POLICY}`, {}));
    return result.payload;
  }
}